import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Grid from '@mui/material/Grid2';
import UsageManualHistoryList from './UsageManualHistoryList';
import UsageManualPreviewPanel from './UsageManualPreviewPanel';
const UsageManualAdminView = ({ manuals, selectedVersionLabel, onSelectVersion, onUploadClick, onEditClick, onAddLanguageClick }) => {
    const selectedManual = manuals.find((v) => v.versionLabel === selectedVersionLabel) ?? manuals[0];
    if (!selectedManual)
        return null;
    return (_jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { size: { xs: 12, lg: 4, xl: 3 }, children: _jsx(UsageManualHistoryList, { manuals: manuals, selectedVersionLabel: selectedManual.versionLabel, onSelect: onSelectVersion }) }), _jsx(Grid, { size: { xs: 12, lg: 8, xl: 9 }, children: _jsx(UsageManualPreviewPanel, { manual: selectedManual, onUploadClick: onUploadClick, onEditClick: onEditClick, onAddLanguageClick: onAddLanguageClick }) })] }));
};
export default UsageManualAdminView;
